import script from "./OrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderView.vue?vue&type=script&setup=true&lang=js"

import "./OrderView.vue?vue&type=style&index=0&id=6e18cfdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e18cfdb"]])

export default __exports__